var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "loading-bar",
      style: { display: _vm.visible ? "block" : "none" },
      attrs: { width: "450px", height: "3px", version: "1.1" }
    },
    [
      _c("path", {
        staticClass: "path",
        attrs: {
          fill: "transparent",
          stroke: "#fff",
          "stroke-width": "4",
          d: "m0 0, 450 0"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          fill: "transparent",
          stroke: "#00A9BA",
          "stroke-width": "4",
          d: "m0 0, 450 0"
        }
      }),
      _vm._v(" "),
      _c("path", {
        staticClass: "line1",
        attrs: {
          fill: "transparent",
          stroke: "#fff",
          "stroke-width": "4",
          d: "m0 0, 450 0"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a331067", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a331067","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/loading/LoadingBar.vue
// module id = null
// module chunks = 